import { render, staticRenderFns } from "./TweetsWidget.vue?vue&type=template&id=787708df&scoped=true&"
import script from "./TweetsWidget.vue?vue&type=script&lang=js&"
export * from "./TweetsWidget.vue?vue&type=script&lang=js&"
import style0 from "./TweetsWidget.vue?vue&type=style&index=0&id=787708df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787708df",
  null
  
)

export default component.exports